import React from 'react';
import { Instagram, Facebook, MessageCircle, Mail } from 'lucide-react';
import { openWhatsApp } from '../utils/whatsapp';
const navLinks = [{
  name: 'Inicio',
  href: '#inicio'
}, {
  name: 'Cabañas',
  href: '#cabanas'
}, {
  name: 'Servicios',
  href: '#servicios'
}, {
  name: 'Galería',
  href: '#galeria'
}, {
  name: 'Ubicación',
  href: '#ubicacion'
}];
export function Footer() {
  const handleWhatsApp = () => {
    openWhatsApp();
  };
  return <footer className="bg-charcoal text-sand-light py-10" data-id="element-140">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="flex flex-col items-center text-center gap-5" data-id="element-142">
          {/* Brand */}
          <div data-id="element-143">
            <h3 className="font-serif text-2xl text-white" data-id="element-144">
              Cabañas El Mirador
            </h3>
            <p className="text-sand-dark text-sm mt-1" data-id="element-145">
              El Durazno, Yacanto de Calamuchita, Córdoba
            </p>
          </div>

          {/* Navigation: 3 + 2 centered */}
          <nav className="flex flex-col items-center gap-2" data-id="element-146">
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-1" data-id="element-147">
              {navLinks.slice(0, 3).map(link => <a key={link.name} href={link.href} className="text-sand-dark hover:text-white text-sm transition-colors" data-id="element-148">
                  {link.name}
                </a>)}
            </div>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-1" data-id="element-149">
              {navLinks.slice(3).map(link => <a key={link.name} href={link.href} className="text-sand-dark hover:text-white text-sm transition-colors" data-id="element-150">
                  {link.name}
                </a>)}
            </div>
          </nav>

          {/* Contact + social */}
          <div className="flex flex-wrap items-center justify-center gap-4" data-id="element-151">
            <button onClick={handleWhatsApp} className="inline-flex items-center gap-2 text-sand-dark hover:text-white text-sm transition-colors" data-id="element-152">
              <MessageCircle size={18} data-id="element-153" />
              +54 9 11 6937 3036
            </button>
            <button onClick={() => window.open('https://wa.me/5491135828477', '_blank')} className="inline-flex items-center gap-2 text-sand-dark hover:text-white text-sm transition-colors" data-id="element-154">
              <MessageCircle size={18} data-id="element-155" />
              +54 9 11 3582 8477
            </button>
            <a href="mailto:cabanasmirador4@gmail.com" className="inline-flex items-center gap-2 text-sand-dark hover:text-white text-sm transition-colors" data-id="element-156">
              <Mail size={18} data-id="element-157" />
              cabanasmirador4@gmail.com
            </a>
            <a href="https://www.instagram.com/cabanas_mirador/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-olive transition-colors" data-id="element-158">
              <Instagram size={18} data-id="element-159" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=100032458406811" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-olive transition-colors" data-id="element-160">
              <Facebook size={18} data-id="element-161" />
            </a>
          </div>

          {/* Copyright */}
          <p className="text-xs text-sand-dark/60 pt-2 border-t border-sand-light/10 w-full" data-id="element-162">
            &copy; {new Date().getFullYear()} Cabañas El Mirador. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}